// Merkliste. Sie liegt im Browser des Besuchers (localStorage) - dafuer
// braucht niemand ein Kundenkonto, und es entstehen keine Daten auf dem
// Server, die im Datenschutz erklaert werden muessten.

const SCHLUESSEL = 'fnMerkliste';

const lesen = () => {
    try {
        return JSON.parse(localStorage.getItem(SCHLUESSEL) || '[]');
    } catch (e) {
        return [];
    }
};

const schreiben = (liste) => {
    try {
        localStorage.setItem(SCHLUESSEL, JSON.stringify(liste));
    } catch (e) {
        // Privater Modus: dann eben keine Merkliste
    }
};

const herzSvg =
    '<svg class="fn-herz-leer" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 20.5S3.5 15 3.5 9.2A4.7 4.7 0 0 1 12 6.6a4.7 4.7 0 0 1 8.5 2.6c0 5.8-8.5 11.3-8.5 11.3z"/></svg>'
    + '<svg class="fn-herz-voll" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 20.5S3.5 15 3.5 9.2A4.7 4.7 0 0 1 12 6.6a4.7 4.7 0 0 1 8.5 2.6c0 5.8-8.5 11.3-8.5 11.3z"/></svg>';

const zaehlerAktualisieren = () => {
    const anzahl = lesen().length;

    document.querySelectorAll('[data-fn-merk-zaehler]').forEach((el) => {
        el.textContent = anzahl;
        el.hidden = anzahl === 0;
    });
};

const knopfStand = (knopf, gemerkt) => {
    knopf.classList.toggle('ist-gemerkt', gemerkt);
    knopf.setAttribute('aria-pressed', gemerkt ? 'true' : 'false');
    knopf.setAttribute('title', gemerkt ? 'Von der Merkliste entfernen' : 'Auf die Merkliste');

    const text = knopf.querySelector('.fn-merk-text');

    if (text) {
        text.textContent = gemerkt ? 'Gemerkt' : 'Merken';
    }
};

const bildPfad = (pfad) => {
    if (!pfad) {
        return '';
    }

    if (/^(https?:)?\/\//.test(pfad) || pfad.charAt(0) === '/') {
        return pfad;
    }

    return '/' + pfad;
};

// Das Geruest steht im Template mod_iso_favorites.html5. Falls die Seite
// einmal ohne dieses Template auskommt, bauen wir es hier nach - mit
// derselben Struktur (.container > .container-inner) wie die uebrigen
// Module, damit die Innenabstaende des Themes greifen.
const zielVorbereiten = () => {
    const vorhanden = document.querySelector('[data-fn-merk-liste]');

    if (vorhanden) {
        return vorhanden;
    }

    const iso = document.querySelector('.mod_iso_favorites, .mod_iso_wishlist');

    if (!iso) {
        return null;
    }

    const bereich = document.createElement('div');
    bereich.className = 'fn-merk-bereich';
    bereich.innerHTML = '<div class="container"><div class="container-inner">'
        + '<h1>Deine Merkliste</h1>'
        + '<p class="fn-merk-leer" data-fn-merk-leer>Du hast noch nichts gemerkt. Tippe bei einem Produkt auf das Herz, dann findest du es hier wieder.<br><a class="button barbell" href="/t-shirts.html">Shirts ansehen</a></p>'
        + '<div class="fn-merk-liste" data-fn-merk-liste></div>'
        + '</div></div>';

    iso.parentNode.insertBefore(bereich, iso.nextSibling);

    return bereich.querySelector('[data-fn-merk-liste]');
};

const navAnlegen = () => {
    if (document.querySelector('.fn-merk-nav')) {
        return;
    }

    const warenkorb = document.querySelector('.container-inner.icons .warenkorb, .icons .warenkorb');

    if (!warenkorb) {
        return;
    }

    const link = document.createElement('a');
    link.className = 'fn-merk-nav';
    link.href = '/favoriten.html';
    link.title = 'Merkliste';
    link.setAttribute('aria-label', 'Merkliste');
    link.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 20.5S3.5 15 3.5 9.2A4.7 4.7 0 0 1 12 6.6a4.7 4.7 0 0 1 8.5 2.6c0 5.8-8.5 11.3-8.5 11.3z"/></svg>'
        + '<span class="fn-merk-zaehler" data-fn-merk-zaehler hidden>0</span>';

    warenkorb.parentNode.insertBefore(link, warenkorb);
};

const listeZeichnen = () => {
    const ziel = zielVorbereiten();

    if (!ziel) {
        return;
    }

    const liste = lesen();
    const leerHinweis = document.querySelector('[data-fn-merk-leer]');

    // Nur Isotopes eigene Meldung ausblenden, nicht das ganze Modul - darin
    // steht seit dem eigenen Template die Ueberschrift und der Leertext.
    document.querySelectorAll('.mod_iso_favorites .message, .mod_iso_wishlist .message')
        .forEach((el) => { el.hidden = true; });

    if (!liste.length) {
        ziel.innerHTML = '';

        if (leerHinweis) {
            leerHinweis.hidden = false;
        }

        return;
    }

    if (leerHinweis) {
        leerHinweis.hidden = true;
    }

    // Die Karte hatte bisher nur "Entfernen" als sichtbare Schaltflaeche -
    // der einzige Knopf auf der Merkliste fuehrte also aus ihr heraus. Der
    // Weg zum Produkt steht jetzt als Erstes da.
    ziel.innerHTML = liste.map((e) =>
        '<div class="fn-merk-karte">'
        + '<a href="' + e.url + '">'
        + (e.bild ? '<img src="' + bildPfad(e.bild) + '" alt="" loading="lazy">' : '')
        + '<h4>' + e.name + '</h4></a>'
        + '<div class="price">' + e.preis + '</div>'
        + '<div class="fn-merk-karte-aktionen">'
        + '<a class="button barbell" href="' + e.url + '">Ansehen</a>'
        + '<button type="button" class="fn-merk-entfernen" data-entfernen="' + e.url + '">Entfernen</button>'
        + '</div>'
        + '</div>'
    ).join('');

    ziel.querySelectorAll('[data-entfernen]').forEach((knopf) => {
        knopf.addEventListener('click', () => {
            const url = knopf.getAttribute('data-entfernen');
            schreiben(lesen().filter((e) => e.url !== url));

            document.querySelectorAll('[data-fn-merk][data-url="' + url + '"]').forEach((k) => knopfStand(k, false));

            zaehlerAktualisieren();
            listeZeichnen();
        });
    });
};

navAnlegen();

document.querySelectorAll('[data-fn-merk]').forEach((knopf) => {
    if (knopf.dataset.fnBereit) {
        return;
    }

    knopf.dataset.fnBereit = '1';
    knopf.insertAdjacentHTML('afterbegin', herzSvg);

    const url = knopf.getAttribute('data-url');
    knopfStand(knopf, lesen().some((e) => e.url === url));

    knopf.addEventListener('click', (ereignis) => {
        ereignis.preventDefault();
        ereignis.stopPropagation();

        const liste = lesen();
        const index = liste.findIndex((e) => e.url === url);

        if (index > -1) {
            liste.splice(index, 1);
        } else {
            liste.unshift({
                url: url,
                name: knopf.getAttribute('data-name') || '',
                bild: knopf.getAttribute('data-bild') || '',
                preis: knopf.getAttribute('data-preis') || ''
            });
        }

        schreiben(liste);
        knopfStand(knopf, index === -1);
        zaehlerAktualisieren();
        listeZeichnen();
    });
});

zaehlerAktualisieren();
listeZeichnen();
